import { useState } from 'react'
import DeclineModal from "../Modals/declineModal"
import AcceptModal from "../Modals/acceptModal"

/**
 * Returns the Visualization Approval row component.
 * 
 * @param {*} param0 
 * @returns The Visualization Approval row component.
 */
const VisualizationRow = ({
  visualizationRequest,
  formatUNIX,
  users,
  setNotification,
  setNotificationShow,
  setNotificationPurpose,
  setRequests
}) => {
  const [openDeclineModal, setOpenDeclineModal] = useState(false);
  const [openAcceptModal, setOpenAcceptModal] = useState(false);

  function getUsersName() {
    let user = users?.find((user) => user.Username === visualizationRequest.userID);

    let firstName = user?.Attributes.find((attribute) => attribute.Name === "given_name").Value;

    let lastName = user?.Attributes.find((attribute) => attribute.Name === "family_name").Value;

    return firstName + " " + lastName;
  }

  return (
    <>
      <tr className="py-12" key={visualizationRequest.PK}>
        <td className="w-full max-w-0 py-4 pl-6 pr-3 text-sm sm:text-base font-medium text-gray-900 sm:w-auto sm:max-w-none sm:pl-6">
          <a
            className="hover:underline"
            target="_blank"
            href={"/metadata-display/" + (visualizationRequest.projectID?.substring(8) || visualizationRequest.projectID)}
          >
            {visualizationRequest.projectTitle}
          </a>

          <dl className="font-normal lg:hidden">
            <dt className="sr-only sm:hidden">Visualition Title</dt>
            <dd className="mt-1 truncate text-gray-500 sm:hidden">{JSON.parse(visualizationRequest.visualization).title}</dd>
          </dl>
        </td>

        <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">
          {JSON.parse(visualizationRequest.visualization).title}
        </td>

        <td className="hidden px-3 py-4 text-sm sm:text-base text-gray-500 sm:table-cell">
          {getUsersName()}
        </td>

        <td className="px-3 py-4 text-sm sm:text-base text-gray-500">
          {formatUNIX(visualizationRequest.createdAt)}
        </td>

        <td className="py-4 pl-3 pr-6 space-y-3 text-right text-sm sm:text-base font-medium sm:space-y-0 sm:space-x-3 sm:pr-6">
          <div className="sm:flex sm:space-x-2 sm:space-y-0 space-y-2">
            <button
              /* Sets the publishStatus to published but doesn't actually update the item in the table yet. Updates the item in the table inside the modal */
              onClick={() => { setOpenAcceptModal(true) }}
              // data-cy={"accept-" + project.title}
              type="button"
              className="rounded-md w-full bg-blue-600 py-1 px-4 text-sm font-medium text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Accept
            </button>
            <button
              /* Sets the publishStatus to rejected but doesn't actually update the item in the table yet. Updates the item in the table inside the modal */
              onClick={() => { setOpenDeclineModal(true) }}
              type="button"
              // data-cy={"reject-" + project.title}
              className="rounded-md w-full py-1 px-4 text-sm font-medium shadow-sm text-gray-700 bg-gray-300 hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Reject
            </button>
          </div>
        </td>
        <DeclineModal
          setOpenDeclineModal={setOpenDeclineModal}
          openDeclineModal={openDeclineModal}
          visualizationRequest={visualizationRequest}
          setNotification={setNotification}
          setNotificationShow={setNotificationShow}
          setNotificationPurpose={setNotificationPurpose}
          setRequests={setRequests}
        />
        <AcceptModal
          setOpenAcceptModal={setOpenAcceptModal}
          openAcceptModal={openAcceptModal}
          visualizationRequest={visualizationRequest}
          setNotification={setNotification}
          setNotificationShow={setNotificationShow}
          setNotificationPurpose={setNotificationPurpose}
          setRequests={setRequests}
        />
      </tr>
    </>
  );
};

export default VisualizationRow;